import { render } from "./ProgressBarPage.vue?vue&type=template&id=2d5a2194"
import script from "./ProgressBarPage.vue?vue&type=script&lang=js"
export * from "./ProgressBarPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__